import { render, staticRenderFns } from "./ChannelReportTable.vue?vue&type=template&id=67be17ec&"
import script from "./ChannelReportTable.vue?vue&type=script&lang=js&"
export * from "./ChannelReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports